import {Control} from "ol/control";

/**
 * Control for a rest button on the map, when drawing areas.
 */
export class ResetControl extends Control {
  /**
   * Element for the control
   */
  element: HTMLElement;

  /**
   * constructo
   * @param customOptions
   */
  constructor(customOptions: any) {
    // use options from caller
    const options = customOptions || {};

    // create button element
    const button = document.createElement('button');
    button.innerHTML = options.label;

    // add warpper for button with default classes from ol
    const element = document.createElement('div');
    element.className = 'ol-unselectable ol-control ol-control-custom-reset';
    element.appendChild(button);

    /**
     * @inheritdoc
     */
    super({
      element,
      target: options.target
    });

    // save the element to show/hide it later
    this.element = element;

    // hide element initially
    this.hide();

    // add click handler
    button.addEventListener('click', options.handleClick, false);
  }

  /**
   * Show the control
   */
  show() {
    this.element.style.display = 'block';
  }

  /**
   * hide the control.
   */
  hide() {
    this.element.style.display = 'none';
  }
}

/**
 * Cancel-Button
 */
export class CancelControl extends ResetControl {}
